import http, {pickData} from './http';
import {API_BASE} from './paths';
import {withPerm} from './perm';

const BASE_URL = API_BASE;

export const getApis = withPerm(async (params = {}) => (await http.get(BASE_URL, { params })).data, 'GET', `${BASE_URL}`);
export const getApi = withPerm(async (id) => pickData(await http.get(`${BASE_URL}/${id}`)), 'GET', `${BASE_URL}/{id}`);
export const createApi = withPerm(async (payload) => (await http.post(BASE_URL, payload, { headers:{'Content-Type':'application/json'} })).data, 'POST', `${BASE_URL}`);
export const updateApi = withPerm(async (id, payload) => (await http.put(`${BASE_URL}/${id}`, payload, { headers:{'Content-Type':'application/json'} })).data, 'PUT', `${BASE_URL}/{id}`);
export const deleteApi = withPerm(async (id) => (await http.delete(`${BASE_URL}/${id}`)).data, 'DELETE', `${BASE_URL}/{id}`);
export const deleteApiBatch = withPerm(async (ids=[]) => (await http.delete(BASE_URL, { data: ids })).data, 'DELETE', `${BASE_URL}`);

// Preview APIs
export const getApiPreview = withPerm(async (method, path) => pickData(await http.get(`${BASE_URL}/preview`, { params: { method, path } })), 'GET', `${BASE_URL}/preview`);
export const saveApiPreview = withPerm(async (payload) => (await http.post(`${BASE_URL}/preview`, payload, { headers:{'Content-Type':'application/json'} })).data, 'POST', `${BASE_URL}/preview`);

// Export DOCX
export const exportApisDoc = withPerm(
  async (params = {}) => await http.get(`${BASE_URL}/export`, { params: { ...params, format: 'docx' }, responseType: 'blob' }),
  'GET',
  `${BASE_URL}/export`
);

export const METHOD_TYPES = ['GET','POST','PUT','PATCH','DELETE'];
